var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{on:{"click":_vm.onSave}},[_vm._v(" SAVE ")])
}
var staticRenderFns = []

export { render, staticRenderFns }